import React, { useContext } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../../../imageService';

const ROZETKA_LINK =
  'https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce;tolshchina139079=obichnie/?utm_source=PMU-sms-LM-40';
const CIG_POSHTA_LINK =
  'https://cig-poshta.in.ua/catalog/swoof/price-0-to-1400/product_cat-lm/?utm_source=cda-sms-LM-40';

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          className={styles.bg}
          src={getImageFromS3('images/25-sms-lm-40/bg.png')}
          alt="bg"
        />

        <img
          className={styles.logo}
          src={getImageFromS3('images/25-sms-lm-40/logo.png')}
          alt="logo"
        />

        <p className={styles.headTitle}>
          <span className={styles.accent}>Скоро великі пачки</span>
          <br />
          <b>Red Label XXL</b> <span className={styles.accent}>та</span>{' '}
          <b>Blue Label XXL 40</b>
        </p>

        <div className={styles.pill}>
          <p>
            <b>зникнуть з полиць</b> ❌
          </p>
        </div>
        <p className={styles.subTitle}>
          Але <b>L&M</b> має незмінні характеристики у пачках формату 20 сигарет
          в лінійці <b>First Cut</b>
        </p>
        <div className={styles.packs40}>
          <img
            className={styles.pack40Red}
            src={getImageFromS3('images/25-sms-lm-40/pack-red-40.png')}
            alt="pack-red-40"
          />
          <img
            className={styles.pack40Blue}
            src={getImageFromS3('images/25-sms-lm-40/pack-blue-40.png')}
            alt="pack-blue-40"
          />
        </div>
        <div className={classNames(styles.specTable, styles.specTable40)}>
          <div className={classNames(styles.specRow, styles.specRowFirst)} />
          <div className={classNames(styles.specRow, styles.specRowSecond)} />
          <div className={classNames(styles.specRow, styles.specRowThird)} />
          <div className={styles.specCenter}>
            <p>формат</p>
            <p>вміст смол</p>
            <p>вміст нікотину</p>
          </div>
          <div className={classNames(styles.specValue, styles.specValueLeft)}>
            <p>40 сигарет</p>
            <p>9 мг</p>
            <p>0.7 мг</p>
          </div>
          <div className={classNames(styles.specValue, styles.specValueRight)}>
            <p>40 сигарет</p>
            <p>6 мг</p>
            <p>0.5 мг</p>
          </div>
        </div>
        <div className={styles.packsFc}>
          <img
            className={styles.packFc}
            src={getImageFromS3('images/25-sms-lm-40/pack-fc-red.png')}
            alt="pack-fc-red"
          />
          <img
            className={styles.packFc}
            src={getImageFromS3('images/25-sms-lm-40/pack-fc-blue.png')}
            alt="pack-fc-blue"
          />
        </div>
        <p className={classNames(styles.packFcLabel, styles.packFcLabelRed)}>
          First Cut Red
        </p>
        <p className={classNames(styles.packFcLabel, styles.packFcLabelBlue)}>
          First Cut Blue
        </p>
        <div className={classNames(styles.specTable, styles.specTable20)}>
          <div className={classNames(styles.specRow, styles.specRowFirst)} />
          <div className={classNames(styles.specRow, styles.specRowSecond)} />
          <div className={classNames(styles.specRow, styles.specRowThird)} />
          <div className={styles.specCenter}>
            <p>формат</p>
            <p>вміст смол</p>
            <p>вміст нікотину</p>
          </div>
          <div className={classNames(styles.specValue, styles.specValueLeft)}>
            <p>20 сигарет</p>
            <p>9 мг</p>
            <p>0.7 мг</p>
          </div>
          <div className={classNames(styles.specValue, styles.specValueRight)}>
            <p>20 сигарет</p>
            <p>6 мг</p>
            <p>0.5 мг</p>
          </div>
        </div>
        <div className={styles.kingSize}>
          <p>“Кінг Сайз” Стандарт</p>
        </div>
        <div className={styles.tobaccoCard}>
          <p className={styles.tobaccoTitle}>Якісний тютюн</p>
          <p className={styles.tobaccoText}>
            за більш доступною ціною в лінійці L&M
          </p>
        </div>
        <div className={styles.filterCard}>
          <div className={styles.filterCardYellow} />
          <p className={styles.filterText}>
            <b>Класичний ацетатний фільтр</b> з високоякісної целюлози
          </p>
        </div>
        <img
          className={styles.filterImage}
          src={getImageFromS3('images/25-sms-lm-40/filter.png')}
          alt="filter"
        />
        <div className={styles.buyCard} />
        <p className={styles.buyTitle}>Де купити?</p>
        <p className={styles.buyDescription}>
          Актуальний асортимент можна знайти у роздрібних точках продажу в
          твоєму місті або на офіційних онлайн сервісах, зокрема:
        </p>
        <div className={styles.buttonContainer}>
          <a
            href={ROZETKA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.buttonItem}
            onClick={() => sendEvent('rozetka')}
          >
            <p>Rozetka</p>
          </a>
          <a
            href={CIG_POSHTA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.buttonItem}
            onClick={() => sendEvent('cig-poshta')}
          >
            <p>Cig-poshta</p>
          </a>
        </div>
      </div>
      <div className={styles.footer}>
        <div>
          <p>Куріння викликає серйозні захворювання та залежність</p>
          <p>Дана інформація про продукт надається відповідно</p>
          <p>до статті 15 Закону України «Про захист прав споживачів»</p>
        </div>
      </div>
      <div className={styles.unsubscribe}>
        <div>
          Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
          інформації про продукцію компаній Philip Morris в Україні.{' '}
          <a href="/unsubscribe?returnLink=25-sms-lm-40">
            Відписатися від SMS тут.
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
